import { Injectable } from '@angular/core';
// import { Http, Response } from '@angular/http';
// import { Observable } from 'rxjs/Observable'
// 
// import 'rxjs/add/operator/catch';
// import 'rxjs/add/observable/throw';

import {Observable, map, debounceTime,distinctUntilChanged, switchMap, delay } from 'rxjs';
// 
// import 'rxjs/add/operator/debounceTime';
// import 'rxjs/add/operator/distinctUntilChanged';
// import 'rxjs/add/operator/switchMap';
// import 'rxjs/add/operator/do';
// import 'rxjs/add/operator/delay';
import { HttpClient, HttpParams } from '@angular/common/http';

import { GlobalFunctionsService } from './global-functions.service';

@Injectable()
export class FileUploaderService {
     constructor(private _http: HttpClient, public gfunc: GlobalFunctionsService) {

    }

      public  uploadImage(formdata: any ) {
       // let _url: string = 'http://localhost/angular4/fileUpload.php';
        let _url: string = this.gfunc.php_apiURL_SSL + '/fileUploadMany.php'; // many just set form field to multiple
        // let _url: string = this.gfunc.php_apiURL + '/fileUpload.php'; // single
        return this._http.post(_url, formdata, { responseType: 'text' })
        // //  //  .catch(this._errorHandler) ;
      }


      public  uploadBrandImage(formdata: any, brand_id ) {
        // let _url: string = 'http://localhost/angular4/fileUpload.php';
         let _url: string = this.gfunc.php_apiURL_SSL + '/fileUploadMany.php?brand_id=' + brand_id; // many just set form field to multiple
         // let _url: string = this.gfunc.php_apiURL + '/fileUpload.php'; // single
         return this._http.post(_url, formdata, { responseType: 'text' })
        //  //  //  .catch(this._errorHandler) ;
       }
 


       public  uploadUserImage(formdata: any, user_id ) {
        // let _url: string = 'http://localhost/angular4/fileUpload.php';
         let _url: string = this.gfunc.php_apiURL_SSL + '/fileUploadMany.php?user_id=' + user_id; // many just set form field to multiple
         // let _url: string = this.gfunc.php_apiURL + '/fileUpload.php'; // single
         return this._http.post(_url, formdata, { responseType: 'text' })
         //  //  .catch(this._errorHandler) ;
       }
 


      public  uploadTraceFiles(formdata: any, trace_id ) {
        // let _url: string = 'http://localhost/angular4/fileUpload.php';
         let _url: string = this.gfunc.php_apiURL_SSL + '/fileUploadMany.php?trace_id=' + trace_id;
         // many just set form field to multiple
         // let _url: string = this.gfunc.php_apiURL + '/fileUpload.php'; // single
         return this._http.post(_url, formdata, { responseType: 'text' })
         //  //  .catch(this._errorHandler) ;
       }
 



        public  uploadMany(formdata: any ) {
            // let _url: string = 'http://localhost/angular4/fileUpload.php';
             let _url: string = this.gfunc.php_apiURL_SSL + '/fileUploadMany.php';
             return this._http.post(_url, formdata, { responseType: 'text' })
             //  //  .catch(this._errorHandler) ;
    }

    private _errorHandler(error: Response) {
        console.error('Error Occured: ' + error);
        return (error || 'Some Error on Server Occured');

    }

       public  getFilesList() {
       // let _url: string = 'http://localhost/angular4/getFilesFromDirectory.php';
        let _url: string = this.gfunc.php_apiURL_SSL +  '/getFilesFromDirectory.php';
        return this._http.get(_url)
        //  //  .catch(this._errorHandler) ;
    }



    public  getBrandsList(brand_id) {
      // let _url: string = 'http://localhost/angular4/getFilesFromDirectory.php';
       let _url: string =  this.gfunc.php_apiURL_SSL +  '/getFilesFromDirectory.php?brand_id=' + brand_id;
       return this._http.get(_url)
       //  //  .catch(this._errorHandler) ;
   }


   public  getUsersList(user_id) {
    // let _url: string = 'http://localhost/angular4/getFilesFromDirectory.php';
     let _url: string =  this.gfunc.php_apiURL_SSL +  '/getFilesFromDirectory.php?user_id=' + user_id;
     return this._http.get(_url)
     //  //  .catch(this._errorHandler) ;
 }


    public getTraceFiles(trace_id) {
        // let _url: string = 'http://localhost/angular4/getFilesFromDirectory.php';
         let _url: string =  this.gfunc.php_apiURL_SSL + '/getFilesFromDirectory.php?trace_id=' + trace_id;
         return this._http.get(_url)
         //  //  .catch(this._errorHandler) ;
     }



     // sharmans
     public getJobFiles(job_id) {
        // let _url: string = 'http://localhost/angular4/getFilesFromDirectory.php';
         let _url: string =  this.gfunc.php_apiURL_SSL + '/getFilesFromDirectory.php?job_id=' + job_id;
         return this._http.get(_url)
         //  //  .catch(this._errorHandler) ;
      }


     // sharmans
     public getJobSubjectFiles(subject_id, subject_number) {
        // let _url: string = 'http://localhost/angular4/getFilesFromDirectory.php';
         // tslint:disable-next-line:max-line-length
         let _url: string =  this.gfunc.php_apiURL_SSL + '/getSubjectFilesFromDirectory.php?subject_id=' + subject_id + '&subject_number=' + subject_number;
         return this._http.get(_url)
         //  //  .catch(this._errorHandler) ;
      }



     public getTraceCandidateFiles(trace_candidate_id) {
        // let _url: string = 'http://localhost/angular4/getFilesFromDirectory.php';
         let _url: string =  this.gfunc.php_apiURL_SSL + '/getFilesFromDirectory.php?trace_candidate_id=' + trace_candidate_id;
         return this._http.get(_url)
         //  //  .catch(this._errorHandler) ;
     }


     public  uploadTraceCandidateFiles(formdata: any, trace_candidate_id ) {
        // let _url: string = 'http://localhost/angular4/fileUpload.php';
         let _url: string =  this.gfunc.php_apiURL_SSL + '/fileUploadMany.php?trace_candidate_id=' + trace_candidate_id;
         // many just set form field to multiple
         // let _url: string =  this.gfunc.php_apiURL_SSL + '/fileUpload.php'; // single
         return this._http.post(_url, formdata, { responseType: 'text' })
         //  //  .catch(this._errorHandler) ;
       }


     // sharmans
     public getDocxTemplateFiles(doc_id) {
      // let _url: string = 'http://localhost/angular4/getFilesFromDirectory.php';
       let _url: string =  this.gfunc.php_apiURL_SSL + '/getFilesFromDirectory.php?doc_id=' + doc_id;
       return this._http.get(_url)
       //  //  .catch(this._errorHandler) ;
    }


    public  uploadDocxTemplateFiles(formdata: any, doc_id ) {
      // let _url: string = 'http://localhost/angular4/fileUpload.php';
       let _url: string =  this.gfunc.php_apiURL_SSL + '/fileUploadMany.php?doc_id=' + doc_id;
       // many just set form field to multiple
       // let _url: string =  this.gfunc.php_apiURL_SSL + '/fileUpload.php'; // single
       return this._http.post(_url, formdata, { responseType: 'text' })
       //  //  .catch(this._errorHandler) ;
     }

     
     
    public  uploadDocxSystemFiles(formdata: any, file_id, file_subject_number ) {
      // let _url: string = 'http://localhost/angular4/fileUpload.php';
       // tslint:disable-next-line:max-line-length
       let _url: string =  this.gfunc.php_apiURL_SSL + '/fileUploadMany.php?file_id=' + file_id + '&file_subject_number=' + file_subject_number;
       // many just set form field to multiple
       // let _url: string =  this.gfunc.php_apiURL_SSL + '/fileUpload.php'; // single
       return this._http.post(_url, formdata, { responseType: 'text' })
       //  //  .catch(this._errorHandler) ;
     }


         // sharmans
         public getDotTemplateFiles(doc_id) {
          // let _url: string = 'http://localhost/angular4/getFilesFromDirectory.php';
           let _url: string =  this.gfunc.php_apiURL_SSL + '/getFilesFromDirectory.php?doc_id=' + doc_id + '&is_original=1';
           return this._http.get(_url)
           //  //  .catch(this._errorHandler) ;
        }

        public getDocxThemeTemplateFiles(doc_id) {
          // let _url: string = 'http://localhost/angular4/getFilesFromDirectory.php';
           let _url: string =  this.gfunc.php_apiURL_SSL + '/getFilesFromDirectory.php?doc_id=' + doc_id + '&is_theme=1';
           return this._http.get(_url)
           //  //  .catch(this._errorHandler) ;
        }


    
        public  uploadDotTemplateFiles(formdata: any, doc_id ) {
          // let _url: string = 'http://localhost/angular4/fileUpload.php';
           let _url: string =  this.gfunc.php_apiURL_SSL + '/fileUploadMany.php?doc_id=' + doc_id + '&is_original=1';
           // many just set form field to multiple
           // let _url: string =  this.gfunc.php_apiURL + '/fileUpload.php'; // single
           return this._http.post(_url, formdata, { responseType: 'text' })
           //  //  .catch(this._errorHandler) ;
         }
    
         public  uploadDocxThemeTemplateFiles(formdata: any, doc_id ) {
          // let _url: string = 'http://localhost/angular4/fileUpload.php';
           let _url: string =  this.gfunc.php_apiURL_SSL + '/fileUploadMany.php?doc_id=' + doc_id + '&is_theme=1';
           // many just set form field to multiple
           // let _url: string =  this.gfunc.php_apiUR + '/fileUpload.php'; // single
           return this._http.post(_url, formdata, { responseType: 'text' })
           //  //  .catch(this._errorHandler) ;
         }
    
     




    // sharmans
    public getEmailTemplateFiles(doc_id) {
      // let _url: string = 'http://localhost/angular4/getFilesFromDirectory.php';
        const _url: string =  this.gfunc.php_apiURL_SSL + '/getFilesFromDirectory.php?doc_id=' + doc_id + '&is_email_template=1';
        return this._http.get(_url)
        //  //  .catch(this._errorHandler) ;
    }

    public  uploadEmailTemplateFiles(formdata: any, doc_id ) {
      // let _url: string = 'http://localhost/angular4/fileUpload.php';
        const _url: string =  this.gfunc.php_apiURL_SSL + '/fileUploadMany.php?doc_id=' + doc_id + '&is_email_template=1';
        // many just set form field to multiple
        // let _url: string =  this.gfunc.php_apiURL + '/fileUpload.php'; // single
        return this._http.post(_url, formdata, { responseType: 'text' })
        //  //  .catch(this._errorHandler) ;
      }


}
